import React, { useEffect } from 'react'
import PropTypes from 'prop-types'
import { applyThemeDefaults, applyThemeProperties } from '../../../themes/themeUtil'

function ThemeOverride ({ variables, children }) {
  useEffect(() => {
    applyThemeProperties(variables || [])
    return () => {
      applyThemeDefaults()
    }
  }, [variables])

  return (
    <>
      {children}
    </>
  )
}

ThemeOverride.propTypes = {
  variables: PropTypes.arrayOf(PropTypes.string).isRequired,
  children: PropTypes.node
}

export default ThemeOverride
